import React from 'react'
import _ from 'lodash/fp'

const PriceDisplay = ({ integerPart, decimalPart, containerClassName }) => {
  const withoutDecimals = _.includes('-', decimalPart)
  const decimalClassName = withoutDecimals ? '' : 'decimal'

  return (
    <span className={`price-display ${containerClassName}`}>
      {integerPart}
      <span className={decimalClassName}>
        {decimalPart}
      </span>
    </span>
  )
}

export default PriceDisplay
